export const citiesList = [
  'Sarajevo',
  'Banja Luka',
  'Banovići',
  'Bihać',
  'Bijeljina',
  'Bosanska Krupa',
  'Brčko',
  'Bužim',
  'Cazin',
  'Doboj',
  'Foča',
  'Goražde',
  'Hadžići',
  'Jajce',
  'Kakanj',
  'Maglaj',
  'Mostar',
  'Neum',
  'Novi Travnik',
  'Prijedor',
  'Sanski Most',
  'Srebrenica',
  'Tešanj',
  'Travnik',
  'Trebinje',
  'Tuzla',
  'Velika Kladuša',
  'Visoko',
  'Zavidovići',
  'Žepče',
  'Živinice',
  'Zenica',
];
